import { render, staticRenderFns } from "./flightReservationMonitor.vue?vue&type=template&id=ba58472a&scoped=true&"
import script from "./flightReservationMonitor.vue?vue&type=script&lang=ts&"
export * from "./flightReservationMonitor.vue?vue&type=script&lang=ts&"
import style0 from "./flightReservationMonitor.vue?vue&type=style&index=0&id=ba58472a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba58472a",
  null
  
)

export default component.exports